import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _dec, _class;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseCommand, DefineCommand } from "./BaseCommand";
export var HealthCheckCommand = (_dec = DefineCommand('TEST_HEALTH_CHECK'), _dec(_class = /*#__PURE__*/function (_BaseCommand) {
  _inherits(HealthCheckCommand, _BaseCommand);
  var _super = _createSuper(HealthCheckCommand);
  function HealthCheckCommand() {
    _classCallCheck(this, HealthCheckCommand);
    return _super.apply(this, arguments);
  }
  return _createClass(HealthCheckCommand);
}(BaseCommand)) || _class);